export * from "./indicators";
export * from "./pillars";
export * from "./journeyStages";
export * from "./periods";

export const APP_NAME = "121 Insights";
export const APP_SUBTITLE = "Jornada de Experiência do Beneficiário";
export const VENDOR = "121Labs / Hazo.ai";

export const DASHBOARD_TABS = Object.freeze({
  EXECUTIVE: "visao-executiva",
  JOURNEY: "jornada",
  DRIVERS: "drivers",
  VERBATINS: "verbatins",
  TRENDS: "tendencias",
  SEGMENTATION: "segmentacao",
  BENCHMARKING: "benchmarking",
  ACTION_PLAN: "plano-acao",
  COOPERACAO: "cooperacao",
  METHODOLOGY: "metodologia",
});

export const DASHBOARD_TABS_ORDER = [
  DASHBOARD_TABS.EXECUTIVE,
  DASHBOARD_TABS.JOURNEY,
  DASHBOARD_TABS.DRIVERS,
  DASHBOARD_TABS.VERBATINS,
  DASHBOARD_TABS.TRENDS,
  DASHBOARD_TABS.SEGMENTATION,
  DASHBOARD_TABS.BENCHMARKING,
  DASHBOARD_TABS.ACTION_PLAN,
  DASHBOARD_TABS.COOPERACAO,
  DASHBOARD_TABS.METHODOLOGY,
];

export const LOADING_STATUSES = Object.freeze({
  IDLE: "idle",
  LOADING: "loading",
  SUCCEEDED: "succeeded",
  FAILED: "failed",
});
